import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class MetaDataBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new MetaDataBox({
            uuid,
            graph,
            name: "MetaDataBox",
            pointerRules: NoPointers,
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "MetaDataBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({});
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitMetaDataBox, this);
    }
    get tags() {
        return MetaDataBox.Tags;
    }
    get target() {
        return this.getField(1);
    }
    get origin() {
        return this.getField(2);
    }
    get value() {
        return this.getField(3);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "target",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.MetaData, true),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "origin",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "value",
                deprecated: false,
                pointerRules: NoPointers,
            }, "{}"),
        };
    }
}
